<template>
    <div class="row">
      <div class="col-12">
        <div class="card mb-25 border-0 rounded-0 bg-white">
                  <div class="card-body p-25">
            <!-- Filtres -->
            <div class="row mb-4">

              <div class="col-md-3">
                <label class="form-label">Période</label>
                <select class="form-select" v-model="selectedPeriod" @change="applyFilters">
                  <option value="all">Toute la période</option>
                  <option value="week">Cette semaine</option>
                  <option value="month">Ce mois</option>
                  <option value="year">Cette année</option>
                </select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Date de début</label>
                <input type="date" class="form-control" v-model="startDate" @change="applyFilters" />
              </div>
              <div class="col-md-3">
                <label class="form-label">Date de fin</label>
                <input type="date" class="form-control" v-model="endDate" @change="applyFilters" />
              </div>
              <!-- <div class="col-md-2">
                <label class="form-label">Rechercher</label>
                <div class="input-group">
                  <input 
                    type="text" 
                    class="form-control" 
                    placeholder="Document..."
                    v-model="searchTerm" 
                    @keyup.enter="applyFilters" />
                  <button class="btn btn-outline-secondary" type="button" @click="applyFilters">
                    <i class="flaticon-search-interface-symbol"></i>
                  </button>
                </div>
              </div> -->
            </div>

            <!-- Statistiques -->
            <!-- <div class="row mb-4">
              <div class="col-md-2">
                <div class="card border-0 bg-light">
                  <div class="card-body text-center p-3">
                    <i class="flaticon-shopping-cart-2 fs-25 text-primary mb-1"></i>
                    <h6 class="fw-bold mb-0">{{ totalTelechargements }}</h6>
                    <small class="text-muted">Total</small>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="card border-0 bg-success bg-opacity-10">
                  <div class="card-body text-center p-3">
                    <i class="flaticon-check fs-25 text-success mb-1"></i>
                    <h6 class="fw-bold mb-0">{{ telechargementsReussis }}</h6>
                    <small class="text-muted">Réussis</small>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="card border-0 bg-danger bg-opacity-10">
                  <div class="card-body text-center p-3">
                    <i class="flaticon-warning fs-25 text-danger mb-1"></i>
                    <h6 class="fw-bold mb-0">{{ telechargementsEchoues }}</h6>
                    <small class="text-muted">Échoués</small>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="card border-0 bg-info bg-opacity-10">
                  <div class="card-body text-center p-3">
                    <i class="flaticon-download fs-25 text-info mb-1"></i>
                    <h6 class="fw-bold mb-0">{{ telechargementsEnCours }}</h6>
                    <small class="text-muted">En cours</small>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="card border-0 bg-warning bg-opacity-10">
                  <div class="card-body text-center p-3">
                    <i class="flaticon-cancel fs-25 text-warning mb-1"></i>
                    <h6 class="fw-bold mb-0">{{ telechargementsInterrompus }}</h6>
                    <small class="text-muted">Interrompus</small>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- Table des emprunts -->
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th>Document</th>
                    <th>Catégorie</th>
                    <th>Date téléchargement</th>
                    <th>Taille du fichier</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="telechargement in telechargements" :key="telechargement.id">
                    <td>
                      <div class="d-flex align-items-center">
                        <div class="flex-shrink-0 me-3">
                          <div class="bg-primary rounded-circle p-2" style="width: 40px; height: 40px;">
                            <i class="flaticon-download text-white fs-16"></i>
                          </div>
                        </div>
                        <div>
                          <h6 class="mb-0 fw-semibold">{{ telechargement.document?.titre || 'Titre non disponible' }}</h6>
                          <small class="text-muted">
                            Par {{ telechargement.document?.auteur.nom || 'Auteur inconnu' }} {{ telechargement.document?.auteur.prenoms || 'Auteur inconnu' }}
                          </small>
                        </div>
                      </div>
                    </td>
                     <td>
                      <span class="badge bg-secondary">
                        {{ telechargement.document?.categorie?.nom || 'Non définie' }}
                      </span>
                    </td>
                    <td>
                      <div>
                        <div class="fw-medium">{{ formatDate(telechargement.createdAt) }}</div>
                        <small class="text-muted">à {{ formatTime(telechargement.createdAt) }}</small>
                      </div>
                    </td>
                    <td>
                      <div>
                        <div class="fw-medium">{{ formatFileSize(telechargement.tailleFichier) }}</div>
                        <small class="text-muted">{{ telechargement.document?.format || 'PDF' }}</small>
                      </div>
                    </td>
                     <td>
                      <div class="d-flex gap-2">
                        <button 
                          class="btn btn-sm btn-outline-success"
                          @click="telechargerDocument(telechargement.document)"
                          title="Télécharger">
                          <i class="flaticon-download"></i> Rétélécharger
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
               <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
              </div>
              
              <!-- Message si aucun téléchargement -->
              <div v-if="telechargements.length === 0" class="text-center py-5">
                <i class="flaticon-download fs-1 text-muted"></i>
                <h5 class="text-muted mt-3">Aucun téléchargement trouvé</h5>
                <p class="text-muted">Votre historique de téléchargements apparaîtra ici.</p>
              </div>
            </div>

            <!-- Pagination -->
            <!-- <div class="d-flex justify-content-between align-items-center mt-4">
              <div class="text-muted">
                Affichage de {{ (page- 1) * itemsPerPage + 1 }} à 
                {{ Math.min(page* itemsPerPage, totalItems) }} sur {{ totalItems }} entrées
              </div>
              <nav>
                <ul class="pagination mb-0">
                  <li class="page-item" :class="{ disabled: page=== 1 }">
                    <button class="page-link" @click="changePage(page- 1)">
                      <i class="flaticon-left-arrow"></i>
                    </button>
                  </li>
                  <li 
                    v-for="page in visiblePages" 
                    :key="page" 
                    class="page-item" 
                    :class="{ active: page === page}">
                    <button class="page-link" @click="changePage(page)">{{ page }}</button>
                  </li>
                  <li class="page-item" :class="{ disabled: page=== totalPages }">
                    <button class="page-link" @click="changePage(page+ 1)">
                      <i class="flaticon-right-arrow"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div> -->
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue';
import ApiService from '@/services/ApiService';
import { error, success, showModal } from '@/utils/utils';
import { useRouter } from 'vue-router';
  import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
  name: 'HistoriqueTelechargement',
  components: {
    PaginationComponent
  },
  
  setup() {
    const router = useRouter();

    // Reactive state
    const telechargements = ref<Array<any>>([]);
    const loading = ref(false);
    const page = ref(1);
    const limit = ref(10);
    const totalElements = ref(0);
    const totalPages = ref(0);
    const selectedTelechargement = ref<any>(null);
    const detailsModalRef = ref<HTMLElement | null>(null);
    const baseUrl = ref(ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0]);


    // Filtres
    const selectedStatus = ref('all');
    const selectedPeriod = ref('all');
    const startDate = ref('');
    const endDate = ref('');
    const searchTerm = ref('');

    // Pagination computed
    const visiblePages = computed(() => {
      const pages: number[] = [];
      const start = Math.max(1, page.value - 2);
      const end = Math.min(totalPages.value, start + 4);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    });
   const telechargerDocument = (document: any) => {
      if (document?.nomFichier) {
        const downloadUrl = `${baseUrl.value}uploads/${document.nomFichier}`;
        window.open(downloadUrl, '_blank');
      }
    };
    // Methods
    const getTelechargements = async () => {
      loading.value = true;
      try {
        const params = new URLSearchParams({
          page: page.value.toString(),
          limit: limit.value.toString()
        });

        if (selectedStatus.value !== 'all') {
          params.append('statut', selectedStatus.value);
        }
        if (searchTerm.value) {
          params.append('search', searchTerm.value);
        }
        if (startDate.value) {
          params.append('startDate', startDate.value);
        }
        if (endDate.value) {
          params.append('endDate', endDate.value);
        }

        const response = await ApiService.get(`/historiques/user/telechargement?${params}`);
        telechargements.value = response.data.data.data;
        totalElements.value = response.data.data.totalElements;
        totalPages.value = response.data.data.totalPages;
      } catch (err) {
        error('Erreur lors du chargement des téléchargements');
      } finally {
        loading.value = false;
      }
    };

     const handlePaginate = ({ page_, limit_ }) => {
          try {
            page.value = page_;
            limit.value = limit_;
            getTelechargements();
          } catch (error) {
            //
            
          }
        };


    const applyFilters = () => {
      if (selectedPeriod.value !== 'all') {
        const now = new Date();
        let start = new Date();
        
        switch (selectedPeriod.value) {
          case 'week':
            start = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            break;
          case 'month':
            start = new Date(now.getFullYear(), now.getMonth(), 1);
            break;
          case 'year':
            start = new Date(now.getFullYear(), 0, 1);
            break;
        }
        
        startDate.value = start.toISOString().split('T')[0];
        endDate.value = now.toISOString().split('T')[0];
      }
      
      page.value = 1;
      getTelechargements();
    };

    const changePage = (newPage: number) => {
      if (newPage >= 1 && newPage <= totalPages.value) {
        page.value = newPage;
        getTelechargements();
      }
    };

    const refreshTelechargements = () => {
      page.value = 1;
      getTelechargements();
    };

    const exportTelechargements = async () => {
      try {
        success('Fonctionnalité d\'export en cours de développement');
      } catch (err) {
        error('Erreur lors de l\'export');
      }
    };

    const voirDetails = (telechargement: any) => {
      selectedTelechargement.value = telechargement;
      showModal(detailsModalRef.value);
    };

    const retelecharger = (telechargement: any) => {
      if (telechargement.document?.id) {
        router.push({
          name: 'pdf-viewer',
          params: { id: telechargement.document.id },
          query: { 
            pdfUrl: `${baseUrl.value}uploads/${telechargement.document.nomFichier}` 
          }
        });
      }
    };

    const relancerTelechargement = async (telechargement: any) => {
      if (confirm('Êtes-vous sûr de vouloir relancer ce téléchargement ?')) {
        try {
          await ApiService.post(`/telechargements/${telechargement.id}/relancer`, {});
          success('Téléchargement relancé avec succès');
          getTelechargements();
        } catch (err) {
          error('Erreur lors de la relance du téléchargement');
        }
      }
    };

    const getStatusClass = (statut: string) => {
      const classes: Record<string, string> = {
        'REUSSI': 'bg-success',
        'ECHOUE': 'bg-danger',
        'EN_COURS': 'bg-info',
        'INTERROMPU': 'bg-warning text-dark'
      };
      return classes[statut] || 'bg-secondary';
    };

    const getStatusText = (statut: string) => {
      const texts: Record<string, string> = {
        'REUSSI': 'Réussi',
        'ECHOUE': 'Échoué',
        'EN_COURS': 'En cours',
        'INTERROMPU': 'Interrompu'
      };
      return texts[statut] || statut;
    };

    const formatFileSize = (bytes: number) => {
      if (!bytes) return '0 B';
      const k = 1024;
      const sizes = ['B', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const formatDuration = (seconds: number) => {
      if (!seconds) return '0s';
      if (seconds < 60) return `${seconds}s`;
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      return `${minutes}m ${remainingSeconds}s`;
    };

    const formatSpeed = (bytesPerSecond: number) => {
      if (!bytesPerSecond) return '';
      return `${formatFileSize(bytesPerSecond)}/s`;
    };

    const formatDate = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString('fr-FR');
    };

    const formatTime = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    };

    // Lifecycle
    onMounted(() => {
      baseUrl.value = ApiService.vueInstance.axios.defaults.baseURL?.split("api")[0];
      getTelechargements();
    });

    // Return all reactive data and methods for template usage
    return {
      // Reactive data
      telechargements,
      loading,
      page,
      totalPages,
      handlePaginate,
      totalElements,
      limit,
      selectedTelechargement,
      detailsModalRef,
      selectedStatus,
      selectedPeriod,
      startDate,
      endDate,
      searchTerm,
      visiblePages,
      
      // Methods
      getTelechargements,
      applyFilters,
      changePage,
      refreshTelechargements,
      exportTelechargements,
      voirDetails,
      retelecharger,
      relancerTelechargement,
      getStatusClass,
      getStatusText,
      formatFileSize,
      formatDuration,
      formatSpeed,
      formatDate,
      formatTime,
      telechargerDocument
    };
  }
});
</script>

<style scoped>
.table th {
  border-top: none;
  font-weight: 600;
  color: #495057;
}

.pagination .page-link {
  border: 1px solid #dee2e6;
  color: #495057;
}

.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

.motif-cell {
  max-width: 200px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
